<template>
	<div class="artwork-reviews">
		<h3 class="mb-2 mt-5">Reviews</h3>

		<div v-if="hasReviews">
			<artwork-review v-for="review in reviews" :key="review.author" :review="review"></artwork-review>
		</div>

		<p v-else>This artwork has not yet been reviewed.</p>
	</div>
</template>

<script>
import ArtworkReview from './ArtworkReview.vue';

export default {
	components: {
		ArtworkReview
	},

	props: {
		artwork: {
			type: Object,
			required: true
		}
	},

	mounted() {

	},

	computed: {
		hasReviews() {
			return this.reviews && this.reviews.length > 0;
		},

		reviews() {
			return this.artwork.reviews;
		}
	}
}
</script>